import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ENV_CONFIG } from 'config/environment';
import { Image } from 'components/Image';
import { getPathWithRef } from 'helpers/utils';
import { trackEvent, SupportOathCTAPlacement } from 'helpers/mixpanelEvents';

interface Props {
  eyebrow: string;
  headline: string;
  body: string;
  buttonText: string;
  disclaimer: string;
  placement: SupportOathCTAPlacement;
  variant?: 'light' | 'dark';
}

const oathIconWhite = `${
  ENV_CONFIG().CLOUD_STORAGE.URL
}/static_content/oath_logos/Oath_Icon_White.png`;

export const SupportOathCTA = ({
  eyebrow,
  headline,
  body,
  buttonText,
  disclaimer,
  placement,
  variant,
}: Props) => {
  return (
    <div
      className={classNames('support-oath-cta', {
        'support-oath-cta-dark': variant === 'dark',
      })}
    >
      <div className="support-oath-cta-row">
        <div className="support-oath-cta-text">
          <div className="support-oath-cta-eyebrow">
            <span className="support-oath-cta-icon">
              <Image alt="" src={oathIconWhite} />
            </span>
            <span className="eyebrow-text">{eyebrow}</span>
          </div>
          <h3 className="support-oath-cta-headline h4-text semi-bold">{headline}</h3>
          <span className="support-oath-cta-body body-text">{body}</span>
        </div>
        <Link
          className={classNames('button-brand support-oath-cta-button', {
            'button-brand-secondary': variant === 'dark',
          })}
          to={getPathWithRef('/donate?p=oath')}
          onClick={() => trackEvent('Support Oath CTA Clicked', { placement })}
        >
          {buttonText}
        </Link>
      </div>
      <span className="support-oath-cta-disclaimer body-small-text">{disclaimer}</span>
    </div>
  );
};
